import React, { memo, useCallback } from "react";
import { InputLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import MuiSearchInput from "@/components/muiCustom/search/MuiSearchInput";

const StyledInputLabel = styled(InputLabel)(() => ({
  fontWeight: 600,
  color: "var(--neutral-700)",
  fontSize: ".92rem",
}));

type TableGlobalFilterProps = {
  globalFilter?: string;
  setGlobalFilter: (_value: string | undefined) => void;
  placeholder?: string;
  debounceTime?: number;
  hideSearchLabel?: boolean;
};

const TableGlobalFilter = ({
  globalFilter,
  setGlobalFilter,
  placeholder = "",
  debounceTime = 200,
  hideSearchLabel = false,
}: TableGlobalFilterProps) => {
  const handleChange = useCallback(
    (nextValue: string) => {
      setGlobalFilter(nextValue?.trim() || undefined);
    },
    [setGlobalFilter]
  );

  return (
    <div className="table-search px-2">
      {!hideSearchLabel && (
        <StyledInputLabel shrink margin="dense" className="mb-0">
          Search
        </StyledInputLabel>
      )}
      <MuiSearchInput
        id="search"
        name="search"
        value={globalFilter || ""}
        onChange={handleChange}
        placeholder={placeholder}
        debounceTime={debounceTime}
        skipInitialChange
      />
    </div>
  );
};

export default memo(TableGlobalFilter);
